<div class="bidlist-filters container border border-dark wrapper" *transloco="let convert;">

  @if (isCollapsed()) {
    <div>
      <button data-testid="bidlist-filters-show-button" _ngcontent-ivq-c13=""
        class="btn btn-link d-inline-block px-0 py-2"
        data-track-elem="button"
        data-track-name="Filters"
        (click)="toggleCollapsed()"
        role="button"><i _ngcontent-ivq-c13="" aria-hidden="true" class="me-1 allycon-filter"></i> {{ convert('vehicles.bidListFilter.btnFilters') }}</button>
      </div>
    }

    @if (!isCollapsed()) {
      <div>
        @if (isMobile()) {
          <div class="back-link">
            <button data-testid="bidlist-filters-close-button" class="btn btn-link p-0" (click)="toggleCollapsed()" data-track-elem="button"
              [attr.data-track-name]="'Close Filters'">
              <i class="me-1 allycon-glyph-chevron-left" aria-hidden="true"></i>
              <span>{{ convert('vehicles.bidListFilter.btnCloseFilters') }}</span>
            </button>
          </div>
        }
        <div class="row ms-0 me-0">
          <div class="bidlist-filters__select bidlist-filters__select-result">
            <user-dropdown data-testid="bidlist-filters-user-dropdown" [userUuids]='bidlist.pagination.metaData.addedByUserUuids'>
            </user-dropdown>
          </div>
          <div class="ms-auto d-flex flex-row">
            <div class="bidlist-filters__select bidlist-buttons">
              <bidlist-status-filter data-testid="bidlist-filters-status-filter"
                [bidListStatusCounts]="bidListStatusCounts"
                [filteredStatus]='getFilterByBidListStatusValue()'>
              </bidlist-status-filter>
            </div>
          </div>
          <div class="ms-auto d-flex flex-row">
            <div class="bidlist-filters__select">
              <app-bidlist-sort-select data-testid="bidlist-filters-sort-select" id="select-sort-by" label="{{ convert('vehicles.bidListFilter.labelSortBy') }}" [selection]="sortValue"
                [disabledFlag]="bidlist.items && bidlist.items.length === 0">
                <label for="select-sort-by" class="app-label border border-danger">{{ convert('vehicles.bidListFilter.labelSortBy') }}</label>
              </app-bidlist-sort-select>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
